var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconImageStroke = function SvgIconImageStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M19.25 3A3.76 3.76 0 0 1 23 6.75v10.5A3.76 3.76 0 0 1 19.25 21H4.75A3.76 3.76 0 0 1 1 17.25V6.75A3.76 3.76 0 0 1 4.75 3zM5.41 12.554a1 1 0 0 0-1.414 0L2.7 13.85v4.45c0 .55.45 1 1 1h8.457zM17 14.7c-2.084 0-4.064.422-5.895 1.143L14.56 19.3h5.74c.55 0 1-.45 1-1v-2.997A16 16 0 0 0 17 14.7M3.7 4.7c-.55 0-1 .45-1 1v5.882c1.448-.914 3.396-.747 4.654.512l2.427 2.428A17.9 17.9 0 0 1 17 13c1.485 0 2.92.194 4.3.537V5.7c0-.55-.45-1-1-1zM17 7a2 2 0 1 1-.001 4.001A2 2 0 0 1 17 7"
  })));
};
export default SvgIconImageStroke;